import { isTruthy } from '@r1-frontend/shared/guards';

import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { ESteps } from '~/src/features/full-buy/types';
import { TState } from '~/src/store';

import { guideSteps } from './data';

export const getGuideData = (state: TState) =>{
    const { flow, stepIndex, selectedTariff } =  state.fullBuy;

    const isSalePackageId = !!((selectedTariff && 'salePackageId' in selectedTariff));
    const tariff  = selectCurrentTariff(state);
    const currentStep = flow?.steps[stepIndex];

    const hasEquipmentInTariff = tariff?.additionalProducts.some(product => product.category === 'router' && product.required);
    const hasRequiredTvBox = tariff?.additionalProducts.find(el => el.category === EShopCategory.Decoders && el.required);
    // @todo replace to a selector. Simplify condition by `!!tariff?.subscriptions Summary?.length && !!tariff?.sale Package Links?.length;`
    const hasSubscriptions = (tariff?.subscriptionsSummary && tariff?.subscriptionsSummary?.length > 0) && (tariff?.salePackageLinks && tariff?.salePackageLinks?.length > 0);

    if (!flow) {
        return undefined;
    }

    return flow.steps
        .map((step) =>{
            const findStep = guideSteps.find(item => item.value === step);

            if (isSalePackageId && findStep?.value === ESteps.tariffInfo) {
                return null;
            }

            if (!hasSubscriptions && findStep?.value === ESteps.subscriptions) {
                return null;
            }
            if ((tariff?.isMono || hasRequiredTvBox) && findStep?.value === ESteps.equipmentsTv) {
                return null;
            }
            if (hasEquipmentInTariff && findStep?.value === ESteps.equipments) {
                return null;
            }
            if (findStep) {
                const { value, ...mappedItem } = { ...findStep, isActive: currentStep === findStep.value }; // eslint-disable-line
                return { ...mappedItem };
            }
            return null;
        })
        .filter(isTruthy);
};
